import React from 'react';

export const ErrorState = ({ title, message }: { title: string; message: string }) => {
    return (
        <div
            className="background-image"
            style={{
                position: 'fixed',
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
                display: 'flex',
                alignItems: 'center',
                boxSizing: 'border-box',
            }}>
            <div
                style={{
                    width: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '2rem',
                    boxSizing: 'border-box',
                }}>
                <div
                    className="alert alert-danger"
                    style={{
                        width: '80%',
                        maxWidth: '600px',
                        margin: 0,
                        padding: '1.5rem 2rem',
                        boxSizing: 'border-box',
                        borderRadius: '8px',
                        boxShadow: '0 8px 30px rgba(0, 0, 0, 0.15)',
                    }}>
                    <h4 style={{ margin: '0 0 0.75rem' }}>{title}</h4>
                    {message}
                </div>
            </div>
        </div>
    );
};
